<template>
  <q-item clickable>
    <q-item-section avatar>
      <q-icon :name="`mdi-email${notification.unread ? '' : '-open-outline'}`" />
    </q-item-section>
    <q-item-section>
      <q-item-label lines="1">{{ notification.title }}</q-item-label>
      <q-item-label caption lines="1">{{ notification.timesince }}</q-item-label>
    </q-item-section>
    <q-item-section side>
      <q-icon
          v-if="notification.unread"
          name="mdi-check"
          :title="$t('notification.menu.markAsRead')"
          @click="$emit('read')"
      />
    </q-item-section>
  </q-item>
</template>

<script lang="ts" setup>
import type { AppNotification } from '#/notification'

defineProps<{
  notification: AppNotification
}>()
</script>

<style scoped>

</style>
